<template>
<div>
    Not found
</div>
</template>

<script>
export default {
    mounted() {
        this.$router.push({ name: "home" });
    }
}
</script>

<style>

</style>
